<template>
  <div v-if="items.length" class="my-8" data-test-id="event-highlights">
    <Heading
      :level="2"
      :title="t('product.show.basicDetails.highlights')"
      h-class="text-h6 font-semibold"
      class="kft-heading--left mt-8 mb-4 text-stone-800"
    />
    <ul
      class="m-0 grid list-none grid-cols-1 gap-x-10 gap-y-3 p-0 md:grid-cols-2"
      data-test-id="event-highlights-list"
    >
      <li
        v-for="(highlight, index) in items"
        :key="`${index}-${highlight}`"
        class="flex items-start gap-2.5"
        :data-test-id="`event-highlight-${index}`"
      >
        <IconCheckCircle
          class="mt-0.5 size-5 shrink-0 text-teal-500"
          aria-hidden="true"
        />
        <span class="text-[14px] leading-[22px] text-stone-600">
          {{ highlight }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { CircleCheck as IconCheckCircle } from 'lucide-vue-next'

const { highlight } = defineProps<{
  highlight?: string[]
}>()

const { t } = useI18n()

const items = computed(() => highlight?.filter(Boolean) ?? [])
</script>
